import React from 'react'

export default function Text() {
  return (
    <section id="impressum" className="imprint">
      <div className="imprint-container">
        <h3 className="imprint-container-title">Impressum</h3>
        <div className="imprint-container-left">
          <div className="imprint-container-address">
            Katholische Akademie in Berlin e.V.
            <br />Hannoversche Str. 5
            <br />10115 Berlin-Mitte
            <br />Tel. (030) 28 30 95-0
            <br />Fax (030) 28 30 95-147
            <br />
            <a
              className="imprint-container-address-link"
              href="mailto:information@katholische-akademie-berlin.de"
            >
              information@katholische-akademie-berlin.de
            </a>
          </div>
        </div>
        <div className="imprint-container-center">
          <div className="imprint-container-director">
            Direktor: Joachim Hake
          </div>
          <div className="imprint-container-register">
            Eintrag im Vereinsregister:
            <br />Amtsgericht Charlottenburg
            <br />Nr. 12277 Nz
          </div>
        </div>
        <div className="imprint-container-right">
          <div className="imprint-container-liability">
            Haftungshinweis: Trotz sorgfältiger inhaltlicher Kontrolle
            übernehmen wir keine Haftung für die Inhalte externer Links. Für den
            Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber
            verantwortlich.
          </div>
        </div>
      </div>
    </section>
  )
}



/** WEBPACK FOOTER **
 ** ./src/components/imprint.js
 **/